import {validateSync, ValidationArguments, ValidationError, ValidatorConstraint, ValidatorConstraintInterface} from 'class-validator';

import {computed, signal} from '@angular/core';

globalThis.isJsonString = function isJsonString(value: string): value is JsonString {
	try {
		JSON.parse(value);
		return true;
	} catch (error) {
		return false;
	}
};

@ValidatorConstraint({name: 'IsJsonString', async: false})
export class IsJsonString implements ValidatorConstraintInterface {
	validate(value: any, validationArguments?: ValidationArguments): Promise<boolean> | boolean {
		try {
			JSON.parse(value);
			return true;
		} catch (error) {
			return false;
		}
	}

	defaultMessage?(validationArguments?: ValidationArguments): string {
		return 'Invalid JSON string';
	}
}

/* -------------------------------------------------------------------------------------------------------------- */

globalThis.classValidatorSignals = function classValidatorSignals(
	this: Constructor & {
		validity: ClassValidatorSignals;
	},
): ClassValidatorSignals {
	const classValidatorSignals: ClassValidatorSignals = {
		errors$: signal<ValidationError[]>([]),
		isValid$: computed(() => this.validity.errors$ && this.validity.errors$()?.length === 0),
		validate: () => {
			this.validity.errors$.set(validateSync(this));
		},
	};

	return classValidatorSignals;
};
